class vendorRelated extends HTMLElement {
    constructor() {
      super();
     // console.log('Get Related Products');
      const searchTerm = this.dataset.vendor;
      const vendor = this.dataset.vendorName;
      const requestUrl = `/search?q=${searchTerm}&view=vendor`;
       // console.log(requestUrl,'REQUEST URL');


      fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
       // console.log(responseText, 'RESPONSE TEXT');
        this.pendingRequestUrl = null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        //console.log(html, 'html');
        const newHtml = html.querySelector('.vendor-grid');
        this.innerHTML = newHtml.outerHTML;
        //this.querySelector('[data-vendor-name]').innerHTML = vendor;
    
      }).then(() => {
        makeSliders();
        //console.log('done and make sliders');
      })
       
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        } else {
          console.error(error);
        }
      });

    }
}

customElements.define('vendor-related', vendorRelated);